var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyslides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758018522036,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12149,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M901.12 116.622222a6.257778 6.257778 0 0 1 6.257778 6.257778v778.24a6.257778 6.257778 0 0 1-6.257778 6.257778H122.88a6.257778 6.257778 0 0 1-6.257778-6.257778V122.88a6.257778 6.257778 0 0 1 6.257778-6.257778h778.24m0-56.888889H122.88A65.991111 65.991111 0 0 0 56.888889 122.88v778.24A65.991111 65.991111 0 0 0 122.88 967.111111h778.24A65.991111 65.991111 0 0 0 967.111111 901.12V122.88A65.991111 65.991111 0 0 0 901.12 56.888889z",
    "p-id": 12150
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M552.391111 581.973333H391.964444v209.351111h-56.888888V274.773333H557.511111c105.244444 5.12 162.702222 56.888889 170.666667 152.462223 0.568889 101.262222-58.595556 153.031111-175.786667 154.737777z m-10.24-256H391.964444v204.231111h150.186667q124.017778 0 126.293333-105.813333c-3.413333-63.715556-42.666667-96.711111-126.293333-98.417778z",
    "p-id": 12151
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyslides);
export default __webpack_public_path__ + "static/media/myslides.0cdff338.svg";
export { ForwardRef as ReactComponent };